<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Affiliati</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="true" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<v-list elevation="0">
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Nuovo affiliato</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-toolbar-items>
						</v-toolbar>

						<v-container>
							<v-text-field hide-details="auto" v-model="search" append-icon="search" label="Search" />
						</v-container>

						<v-data-table
							:headers="headers"
							:items="getAffiliates"
							:search="search"
							item-key="_id"
							class="elevation-0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="affiliate-admin-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || 'Affiliato'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Password</span>
													<v-chip x-small dark :color="item.hasPassword ? 'success' : 'grey'">
														{{ item.hasPassword ? 'Impostata' : 'Assente' }}
													</v-chip>
												</div>
												<div class="d-flex align-center justify-space-between mt-2">
													<span class="card-label">Attivo</span>
													<v-switch
														v-model="item.active"
														:loading="togglingId === item._id"
														:disabled="togglingId === item._id"
														color="primary"
														hide-details
														dense
														class="mt-0 pt-0"
														@change="toggleActive(item)"
													></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>{{ item.name }}</td>
										<td>{{ item.reference }}</td>
										<td>{{ item.email }}</td>
										<td>{{ item.gettone }}</td>
										<td>{{ commissionLabel(item.commission) }}</td>
										<td>
											<v-chip x-small dark :color="item.hasPassword ? 'success' : 'grey'">
												{{ item.hasPassword ? 'Impostata' : 'Assente' }}
											</v-chip>
										</td>
										<td>
											<v-switch
												v-model="item.active"
												:loading="togglingId === item._id"
												:disabled="togglingId === item._id"
												color="primary"
												hide-details
												class="mt-0 pt-0"
												@change="toggleActive(item)"
											></v-switch>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando l'affiliato non potrai piu' ripristinarlo.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text :disabled="deleting" @click="dialogconfirm = false">Annulla</v-btn>
					<v-btn color="error" :loading="deleting" @click.prevent="confirmDelete">Elimina</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @event="initialize" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="initialize" @message="propSetMessages"></FormCreate>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormCreate = () => import('@/components/manage/affiliates/Create.vue');
const FormEdit = () => import('@/components/manage/affiliates/Edit.vue');

export default {
	name: 'AffiliatesManage',
	components: { FormCreate, FormEdit, KeyValueCard },
	data() {
		return {
			search: '',
			componentKey: 0,
			operation: '',
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Nome', value: 'name' },
				{ text: 'Referente', value: 'reference' },
				{ text: 'Email', value: 'email' },
				{ text: 'Gettone', value: 'gettone' },
				{ text: 'Commissione', value: 'commission' },
				{ text: 'Password', value: 'hasPassword', sortable: false },
				{ text: 'Attivo', value: 'active', sortable: false },
			],
			dialogconfirm: false,
			deleteTarget: { _id: '', name: '' },
			deleting: false,
			togglingId: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: 'multi-line',
				timeout: 5000,
				text: '',
			},
		};
	},
	created() {
		this.initialize();
	},
	mounted() {
		this.setDialog(false);
	},
	computed: {
		...mapGetters({
			getAffiliates: 'affiliates/getAffiliates',
			getDialog: 'settings/getDialog',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
			setSelected: 'affiliates/setSelected',
		}),
		...mapActions({
			fetchAffiliates: 'affiliates/asyncFetchAffiliates',
			patchActive: 'affiliates/patchActive',
			destroyAffiliate: 'affiliates/deleteAffiliate',
		}),
		// messaggio di esito emesso dai form di creazione/modifica
		propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
		},
		// coppie chiave/valore della card da telefono
		campiCard(item) {
			return [
				{ label: 'Referente', value: item.reference },
				{ label: 'Email', value: item.email },
				{ label: 'Gettone', value: item.gettone },
				{ label: 'Commissione', value: this.commissionLabel(item.commission), strong: true },
			];
		},
		commissionLabel(value) {
			return `${+value || 0}%`;
		},
		async initialize() {
			try {
				await this.fetchAffiliates();
			} catch (err) {
				console.log(err);
			}
		},
		createItem() {
			this.componentKey += 1;
			this.operation = 'FormCreate';
			this.setSelected({});
			this.setDialog(true);
		},
		editItem(item) {
			if (!item) return;
			this.componentKey += 1;
			this.operation = 'FormEdit';
			this.setSelected(item);
			this.setDialog(true);
		},
		deleteItem(item) {
			this.deleteTarget = { _id: item._id, name: item.name || '' };
			this.dialogconfirm = true;
		},
		async confirmDelete() {
			this.deleting = true;
			try {
				await this.destroyAffiliate({ _id: this.deleteTarget._id });
				this.dialogconfirm = false;
				this.snackbar.color = 'success';
				this.snackbar.text = `Affiliato "${this.deleteTarget.name}" eliminato`;
				this.snackbar.snackbar = true;
			} catch (err) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante eliminazione';
				this.snackbar.snackbar = true;
				if (err.response && err.response.status === 401) {
					this.$router.push('/login');
				}
			} finally {
				this.deleting = false;
			}
		},
		async toggleActive(item) {
			this.togglingId = item._id;
			try {
				await this.patchActive({ _id: item._id, active: item.active });
				this.snackbar.color = 'success';
				this.snackbar.text = item.active ? 'Affiliato attivato' : 'Affiliato disattivato';
				this.snackbar.snackbar = true;
			} catch (err) {
				// revert dello switch in caso di errore
				item.active = !item.active;
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore aggiornamento stato';
				this.snackbar.snackbar = true;
				if (err.response && err.response.status === 401) {
					this.$router.push('/login');
				}
			} finally {
				this.togglingId = '';
			}
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.affiliate-admin-cards,
.affiliate-admin-cards tr {
	display: block;
	width: 100%;
}
.affiliate-admin-cards tr,
.affiliate-admin-cards tr:hover {
	background: transparent !important;
}
.affiliate-admin-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.affiliate-admin-cards tr:first-child td {
	padding-top: 12px !important;
}
.affiliate-admin-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.affiliate-admin-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
